// package: newsmanager
// file: news-manager.proto

var news_manager_pb = require("./news-manager_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var NewsManager = (function () {
  function NewsManager() {}
  NewsManager.serviceName = "newsmanager.NewsManager";
  return NewsManager;
}());

NewsManager.GetCalendarEventList = {
  methodName: "GetCalendarEventList",
  service: NewsManager,
  requestStream: false,
  responseStream: false,
  requestType: news_manager_pb.CalendarEventListReq,
  responseType: news_manager_pb.CalendarEventListReply
};

NewsManager.GetMarketNewsList = {
  methodName: "GetMarketNewsList",
  service: NewsManager,
  requestStream: false,
  responseStream: false,
  requestType: news_manager_pb.MarketNewsListReq,
  responseType: news_manager_pb.MarketNewsListReply
};

NewsManager.ToggleNewsBookmark = {
  methodName: "ToggleNewsBookmark",
  service: NewsManager,
  requestStream: false,
  responseStream: false,
  requestType: news_manager_pb.ToggleNewsBookmarkReq,
  responseType: news_manager_pb.ToggleNewsBookmarkReply
};

NewsManager.CreateCalendarEventAlert = {
  methodName: "CreateCalendarEventAlert",
  service: NewsManager,
  requestStream: false,
  responseStream: false,
  requestType: news_manager_pb.CreateCalendarEventAlertReq,
  responseType: news_manager_pb.CreateCalendarEventAlertReply
};

NewsManager.ListMyAlerts = {
  methodName: "ListMyAlerts",
  service: NewsManager,
  requestStream: false,
  responseStream: false,
  requestType: news_manager_pb.ListMyAlertsReq,
  responseType: news_manager_pb.ListMyAlertsReply
};

NewsManager.UpdateCalendarEventAlert = {
  methodName: "UpdateCalendarEventAlert",
  service: NewsManager,
  requestStream: false,
  responseStream: false,
  requestType: news_manager_pb.UpdateCalendarEventAlertReq,
  responseType: news_manager_pb.UpdateCalendarEventAlertReply
};

NewsManager.DeleteCalendarEventAlert = {
  methodName: "DeleteCalendarEventAlert",
  service: NewsManager,
  requestStream: false,
  responseStream: false,
  requestType: news_manager_pb.DeleteCalendarEventAlertReq,
  responseType: news_manager_pb.DeleteCalendarEventAlertReply
};

exports.NewsManager = NewsManager;

function NewsManagerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

NewsManagerClient.prototype.getCalendarEventList = function getCalendarEventList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NewsManager.GetCalendarEventList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NewsManagerClient.prototype.getMarketNewsList = function getMarketNewsList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NewsManager.GetMarketNewsList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NewsManagerClient.prototype.toggleNewsBookmark = function toggleNewsBookmark(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NewsManager.ToggleNewsBookmark, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NewsManagerClient.prototype.createCalendarEventAlert = function createCalendarEventAlert(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NewsManager.CreateCalendarEventAlert, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NewsManagerClient.prototype.listMyAlerts = function listMyAlerts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NewsManager.ListMyAlerts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NewsManagerClient.prototype.updateCalendarEventAlert = function updateCalendarEventAlert(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NewsManager.UpdateCalendarEventAlert, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NewsManagerClient.prototype.deleteCalendarEventAlert = function deleteCalendarEventAlert(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NewsManager.DeleteCalendarEventAlert, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.NewsManagerClient = NewsManagerClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "newsmanager.Internal";
  return Internal;
}());

Internal.GetCalendarEventList = {
  methodName: "GetCalendarEventList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: news_manager_pb.CalendarEventListReq,
  responseType: news_manager_pb.CalendarEventListReply
};

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalClient.prototype.getCalendarEventList = function getCalendarEventList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.GetCalendarEventList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalClient = InternalClient;

